module.exports = '1.0.3';


/*****************
 ** WEBPACK FOOTER
 ** ./~/sockjs-client/lib/version.js
 ** module id = 294
 ** module chunks = 0
 **/